export const name = 'user-guide-scopes';
export const title = 'User Guide';
export const apiName = 'user-guide-scopes';
